// The browser tab's title: the screen you are on, then the product. Every page used to be titled just
// "Symphony", so the back button's history menu was a column of identical entries with nothing to choose
// between (reported 2026-10-24). An open chat names its conversation instead (FloatingChat), because that
// is what the reader is looking at.
//
// Each screen reuses the i18n key its own heading or nav entry already shows, so the tab reads the same
// words as the page in every locale. A route with no entry here keeps the bare product name.
//
// Web-only by construction: a phone app has no tab title and no browser history menu.

/** Route prefix → the i18n key of that screen's name. Longest prefix wins. */
const ROUTE_TITLE_KEYS: Record<string, string> = {
  '/': 'nav.catchUp',
  '/tasks': 'tasks.title',
  '/files': 'files.title',
  '/chats': 'chats.title',
  '/contacts': 'contacts.title',
  '/agents': 'nav.yourAgents',
  '/agents/activity': 'nav.activity',
  '/activity': 'nav.activity',
  '/calendar': 'calendar.title',
  '/routines': 'routines.title',
  '/wins': 'wins.title',
  '/notifications': 'notifications.title',
  '/compliance': 'compliance.title',
  '/connectors': 'nav.connectors',
  '/settings': 'nav.settings',
  '/settings/connectors': 'nav.connectors',
};

/** The i18n key naming the screen at `pathname` (a Next route pattern or a plain path), if it has one. */
export function routeTitleKey(pathname: string): string | undefined {
  if (pathname === '/') return ROUTE_TITLE_KEYS['/'];
  let best: string | undefined;
  for (const prefix of Object.keys(ROUTE_TITLE_KEYS)) {
    if (prefix === '/') continue;
    const matches = pathname === prefix || pathname.startsWith(`${prefix}/`);
    if (matches && (!best || prefix.length > best.length)) best = prefix;
  }
  return best ? ROUTE_TITLE_KEYS[best] : undefined;
}

/** `"<what> · <product>"`, or the product alone when there is nothing to name. */
export function documentTitle(productName: string, what?: string): string {
  const name = what?.trim();
  return name ? `${name} · ${productName}` : productName;
}
